import "./src/styles/global.css";
import { wrapMDX } from "./root-mdx";
import React from "react";
import Layout from "./src/components/layout";
import LayoutData from "./src/components/layoutData";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { CookieConsentBanner } from "./src/components/cookie-consent-banner";

const loadGetQuantyConsent = (retries = 5) => {
  const siteId = process.env.GATSBY_GETQUANTY_ID;
  if (!siteId) return;

  if (typeof window.GQset_cookie !== "function" && retries > 0) {
    setTimeout(() => loadGetQuantyConsent(retries - 1), 500);
    return;
  }

  const script = document.createElement("script");
  script.src = `https://get.smart-data-systems.com/gq?site_id=${siteId}&consent=1`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
};

const getCookieValue = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
};

export const onClientEntry = () => {
  if (typeof window !== "undefined" && getCookieValue("gatsby-gdpr-getquanty") === "true") {
    loadGetQuantyConsent();
  }
};

export const wrapRootElement = ({ element }) => {
  const withMDX = wrapMDX({ element });
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
    >
      {withMDX}
      <CookieConsentBanner
        backgroundWrapperClasses="cookie-notice backdrop-filter backdrop-blur-sm backdrop-saturate-150 bg-opacity-80 bg-yellow fixed w-full z-50 pt-4 pb-8 lg:py-4 px-3 bottom-0 shadow-2"
        backgroundClasses="flex flex-col lg:flex-row flex-wrap justify-between items-start lg:items-center w-full"
        wrapperClasses="flex items-center gap-2 shrink-0 w-full lg:w-auto justify-between"
        acceptButtonText="Accepter"
        acceptButtonClasses="btn secondary md select-none whitespace-nowrap"
        buttonWrapperClasses="flex gap-2"
        declineButton={true}
        declineButtonText="Refuser"
        declineButtonClasses="btn secondary md select-none whitespace-nowrap"
        personalizeButtonEnable={true}
        personalizeButtonText="Personnaliser"
        personalizeButtonClasses="underline text-gray-700 text-sm cursor-pointer whitespace-nowrap"
        personalizeValidationText="Enregistrer mes préférences"
        personalizeValidationClasses="btn secondary md select-none mt-4"
        personalizeValidationWrapperClasses="w-full"
        cookieListClasses="flex flex-col gap-2 mt-4 w-full"
        cookieMapClasses="flex items-center gap-x-2 flex-wrap"
        cookieTitleClasses="font-bold"
      >
        <p>
          Le site VingtCinq utilise des cookies pour améliorer l'expérience de
          navigation
        </p>
      </CookieConsentBanner>
    </GoogleReCaptchaProvider>
  );
};

export function wrapPageElement({ element, props }) {
  return props.pageContext.layout === "data" ? (
    <LayoutData {...props}>{element}</LayoutData>
  ) : (
    <Layout {...props}>{element}</Layout>
  );
}

export function shouldUpdateScroll({
  routerProps: { location },
  getSavedScrollPosition,
}) {
  return false;
}
